import React, { useEffect, useState } from "react";
import { CenterPopup } from "../../../components/model-popup/center-popup";
import { getVitalsHistory } from "../../../api/list";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { IoCopyOutline } from "react-icons/io5";
import { BsCheckCircleFill } from "react-icons/bs";
import Table from "../../../components/table/table";

interface Props {
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  title: string;
  patientId: number;
  limit: number;
  observation: any;
}
const Popup = (props: Props) => {
  const [vitals, setVitals] = useState<any>([]);
  const [copied, setCopied] = useState<any>(null);
  const [loader, setLoader] = useState(false);
  const tabs = [
    { name: "All", value: "all" },
    { name: "Blood Pressure", value: "bloodPressure" },
    { name: "Temperature", value: "temperature" },
    { name: "Pulse", value: "heartrate" },
    { name: "Weight", value: "weight" },
    { name: "Resp", value: "respirations" },
    { name: "BS", value: "bloodSugar" },
    { name: "O2", value: "oxygenSaturation" },
    { name: "Pain", value: "painLevel" },
    { name: "Height", value: "height" },
  ];

  const [activeTab, setActiveTab] = useState(tabs[0]?.value) as any;

  /**
   * @function handleCopy
   * @returns Null
   * @description Handle Copy
   * */
  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  useEffect(() => {
    setLoader(true);
    getVitalsHistory(props.patientId, {
      type: activeTab === "all" ? "" : activeTab,
      limit: props.limit,
    }).then((res: any) => {
      setVitals(res?.result?.data || []);
      setLoader(false);
    });
  }, [activeTab]);

  return (
    <div>
      <CenterPopup
        showModal={props.showModal}
        setShowModal={props.setShowModal}
        title={props.title}
        popupDiv="w-full !p-0 rounded-none"
        OuterDiv="h-[100vh]"
        // eslint-disable-next-line
        children={
          <>
            <div className="grid grid-cols-12">
              <div className="col-span-12 flex items-center">
                <div className="sm:hidden">
                  <label htmlFor="tabs" className="sr-only">
                    Select a tab
                  </label>
                  <select
                    id="tabs"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    value={activeTab?.value}
                    onChange={(e) => setActiveTab(e.target.value)}
                  >
                    {tabs.map((tab) => (
                      <option key={tab?.name} value={tab?.value}>
                        {tab?.name}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Desktop Tabs */}
                <ul className="hidden w-full text-sm font-medium text-center text-gray-500 rounded-lg shadow-sm sm:flex dark:divide-gray-700 dark:text-gray-400">
                  {tabs.map((tab, index) => (
                    <li key={tab?.name} className="w-full focus-within:z-10">
                      <button
                        onClick={() => {
                          setActiveTab(tab?.value);
                        }}
                        className={`inline-block w-full p-4 border-r border-gray-200 dark:border-gray-700  ${
                          activeTab === tab.value
                            ? "text-gray-900 bg-tertiary-light dark:bg-gray-700 dark:text-white"
                            : "bg-white dark:bg-gray-800 hover:text-gray-700 hover:bg-gray-50 dark:hover:text-white dark:hover:bg-gray-700"
                        }`}
                      >
                        {tab?.name}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className=" flex col-span-12 justify-end">
                {vitals?.length > 0 ? (
                  <CopyToClipboard
                    text={
                      activeTab === "all"
                        ? vitals?.length > 0
                          ? `Value     type          Date\n` + // Notice 15 spaces between headers
                            vitals
                              ?.map(
                                (item: any) =>
                                  `${item?.showvalue} ${item?.type}    ${item?.recordedDate}`
                              )
                              .join("\n")
                          : "No Results Found"
                        : vitals?.length > 0
                        ? `Value               Date\n` + // Notice 15 spaces between headers
                          vitals
                            ?.map(
                              (item: any) =>
                                `${item?.showvalue}    ${item?.recordedDate}`
                            )
                            .join("\n")
                        : "No Results Found"
                    }
                    onCopy={() =>
                      vitals && vitals?.length > 0 ? handleCopy() : null
                    } // Handle the copy event
                    options={{
                      message: "Copied to clipboard",
                    }}
                  >
                    <button
                      className="mt-4 border border-[#dddddd] text-primary-light bg-white py-2 px-3 rounded-lg
                        font-[600] text-xs text-center cursor-pointer
                     "
                    >
                      <span className="flex items-center justify-center">
                        Copy to Clipboard &nbsp;&nbsp;{" "}
                        {copied ? (
                          <BsCheckCircleFill size={15} color="green" />
                        ) : (
                          <IoCopyOutline size={15} />
                        )}
                      </span>
                    </button>
                  </CopyToClipboard>
                ) : (
                  <button
                    className="mt-4  border border-[#dddddd] text-primary_disable-light bg-white py-2 px-4 rounded-lg
                      font-[600] text-xs text-center cursor-not-allowed 
                   "
                    disabled={true}
                  >
                    <span className="flex items-center justify-center">
                      Copy to Clipboard &nbsp;&nbsp;{" "}
                      {copied ? (
                        <BsCheckCircleFill size={15} color="green" />
                      ) : (
                        <IoCopyOutline size={15} />
                      )}
                    </span>
                  </button>
                )}
              </div>
            </div>
            <Table 
              loading={loader}
              data={vitals}
              tableScroll={"100%"}
              columns={[
                "Date",
                ...(activeTab === "all" ? ["Type"] : []),
                "Method",
                "Value"
              ]}
              sort={true}
              columnColSpans={[3, 3, 3, ...(activeTab === "all" ? [3] : []),]}
              scopedSlots={{
                Date: ({ row }: any) => (
                  <td colSpan={3}>
                    {row?.recordedDate ? row?.recordedDate : "-"}
                  </td>
                ),
                Type: ({ row }: any) => (
                  <td colSpan={3}>
                    {row?.type
                              ? row?.type
                              ?.replace(/([A-Z])/g, " $1") // Add space before capital letters
                              ?.toLowerCase() // Convert to lowercase
                              ?.replace(/\b\w/g, (char: any) =>
                                char.toUpperCase()
                            ) || ""
                            : "-"}
                  </td>
                ),
                Method: ({ row }: any) => (
                  <td colSpan={3}>
                    {row?.method ? row?.method : "-"}
                  </td>
                ),
                Value: ({ row }: any) => (
                  <td colSpan={3}>
                    {row?.showvalue ? row?.showvalue : "-"}
                  </td>
                ),
              }}
            />
          </>
        }
      />
    </div>
  );
};

export default Popup;
